module.exports = __webpack_public_path__ + "img/dp_lp_pc_bg_2.520f05a5.jpg";